module.exports = __webpack_public_path__ + "static/media/w (43).389198ed.jpg";